<template>
    <ion-card class="floating floating-large">
        <ion-card-header>
            <ion-card-title>{{ $t('ncrypt.settings_title') }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <settings-list-item v-for="(setting, key) in settings"
                                :key="`${key}`"
                                :setting="setting"
                                :label="key"></settings-list-item>

            <br/>

            <ion-button @click="submit()">
                <ion-icon ios='save' md="save" slot="start"></ion-icon>

                {{ $t('ncrypt.save') }}
            </ion-button>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import {Notifier} from "@/services/Notifier";
    import {ApiError} from "@/errors/ApiError";
    import {SETTINGS_MUTATION} from "@/const/mutation-types";
    import SettingsListItem from "./SettingsListItem";

    export default {
        name: "UserSettings",
        components: {
            SettingsListItem,
        },
        computed: {
            settings() {
                const userSettings = Object.entries(this.$store.getters.settings)
                    .filter(([key, item]) => !item.company_only && !item.covid_only);

                return Object.fromEntries(userSettings);
            },
        },
        methods: {
            saveData() {
                const saveData = {};

                Object.entries(this.settings)
                    .filter(([key, item]) => !item.inherited)
                    .forEach(([key, item]) => saveData[key] = item.value);

                return saveData;
            },
            async submit() {
                const loader = await this.$ionic.loadingController.create({
                    message: this.$t('ncrypt.details_are_being_saved'),
                    duration: 1000000,
                });

                await loader.present();

                this.$http.post('/account/user/settings-update', {
                    settings: this.saveData(),
                })
                    .then(async ({data}) => {
                        if (!data || !data.success) {
                            new ApiError(data);
                            return;
                        }

                        this.$store.commit(SETTINGS_MUTATION, data.settings);

                        await Notifier.showToast({
                            message: this.$t('ncrypt.details_are_saved'),
                        })
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => loader.dismiss())
            },
        }
    }
</script>
